export default __webpack_public_path__ + "static/media/mf.9837f9cd.svg";